
import { addFault } from '@/api/order';
import { getFault } from '@/api/other';
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import OrderItemSearch from '@/components/OrderItemSearch/index.vue';
import { isArray } from 'vue-types/dist/utils';

@Component({
  name: 'EditDialog',
  components: {
    OrderItemSearch }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  faultItemVisibility!: any;
  @Prop({
    type: String,
    default: ''
  })
  companyId!: string;
  @Prop({
    type: Object,
    default: () => {}
  })  
  orderDetail!: any;
  @Prop({
    type: Boolean,
    default: false
  })
  isPhenomenon:any

   @Prop({
     type: Number,
     default: 1
   })
  enterType!: any;
  // 1 报修添加 2 添加订单 3 处理

  private isShowSearch = false

  private formInformation:any={
    faultTypeParent: '',
    faultType: '',
    faultTypeChild: '',
  }
  private faultList: any = [];
  private faultList2: any = [];
  private faultList3: any = [];

  created() {
    this.getFault(0,1, true);
  }
  // 获取故障类型类表
  private getFault(pid: any,level:any, isSet0:any) {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      pid: pid,
      name: '',
      is_need_child: 0,
      page: 1,
      size: 9999
    };
    if (this.isPhenomenon) {
      params.type = 2;
    }
    getFault(params)
      .then((res: any) => {
        if (res.data && res.data.list) {
          switch (level) {
            case 1:
              this.faultList = res.data.list;
              break;
            case 2:
              this.faultList2 = res.data.list;
              //检查faultList2是否是数组且长度为1
              if (isSet0 && Array.isArray(this.faultList2) && this.faultList2.length==1) {
                // this.formInformation.faultType = this.faultList2[0];
              }
              break;
            case 3:
              this.faultList3 = res.data.list;
              if (isSet0 && Array.isArray(this.faultList3) && this.faultList3.length==1 ) {
                this.formInformation.faultTypeChild = this.faultList3[0];
              }
              break;
          }
          // if (pid === 0) {
          //   this.faultList = res.data.list;
          // } else {
          //   this.faultList2 = res.data.list;
          //   if (isSet0) {
          //     this.formInformation.faultType = this.faultList2[0];
          //   }
          // }
        } else {
          switch (level) {
            case 1:
              this.faultList =  [];
              break;
            case 2:
              this.faultList2 =  [];
              break;
            case 3:
              this.faultList3 =  [];
              break;
          }
          // if (pid === 0) {
          //   this.faultList = [];
          // } else {
          //   this.faultList2 = [];
          // }
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private comfirmSelectFault() {
    // 处理
    const tipStr = this.isPhenomenon?'故障现象':'故障类型'
    //没有二级
    if( this.faultList  && this.faultList.length>0 && (!this.formInformation.faultTypeParent || (this.formInformation.faultTypeParent && this.formInformation.faultTypeParent=="") || (this.formInformation.faultTypeParent && !this.formInformation.faultTypeParent.id)) ){
      this.showErrorMsg('请选择'+tipStr);
      return;
    }
    if( this.faultList2 && this.faultList2.length>0 && (!this.formInformation.faultType || (this.formInformation.faultType && this.formInformation.faultType=="") || (this.formInformation.faultType && !this.formInformation.faultType.id)) ){
      this.showErrorMsg('请选择下级'+tipStr);
      return;
    }
    //有二级 判断三级
    if(this.faultList3 && this.faultList3.length>0 && (!this.formInformation.faultTypeChild || (this.formInformation.faultTypeChild && this.formInformation.faultTypeChild=="") || (this.formInformation.faultTypeChild && !this.formInformation.faultTypeChild.id )) ){
      this.showErrorMsg('请选择下级'+tipStr);
      return;
    }
    
    switch (this.enterType) {
      case 1:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 2:
        this.$emit('comfirmHandle', this.formInformation);
        break;
      case 3:
        this.addFaultHandle(
          this.formInformation.faultTypeParent,
          this.formInformation.faultType,
          this.formInformation.faultTypeChild,
        );
        break;
    }
  
  }
  private addFaultHandle(valp: any, val: any ,valc: any) {
    if (!valp) {
      const tipStr = this.isPhenomenon?'故障现象':'故障类型'
      this.showErrorMsg('请选择'+tipStr);
      return;
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      p_fault_type_id: valp.id,
      p_fault_type_name: valp.name,
      fault_type_id: val.id,
      fault_type_name: val.name,
      c_fault_type_id: valc.id,
      c_fault_type_name: valc.name,
      level: valc.level!="" ? valc.level : val.level,
    };
    if (this.isPhenomenon) {
      params.type = 2;
    }
    if (this.orderDetail.order) {
      params.order_id = this.orderDetail.order.id;
    }
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addFault(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.formInformation.faultTypeParent = '';
        this.formInformation.faultType = '';
        this.formInformation.faultTypeChild = '';  
        this.$emit('comfirmHandle', false);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 选中故障类型
  private selectFault(val: any) {
    if (val.id) {
      // 东改 用户可能删除故障类型
      this.formInformation.faultType = {};
      this.formInformation.faultTypeChild  = {};
      this.faultList2 = [];
      this.faultList3 = [];
      this.getFault(val.id,2, true);
    }
    // this.faultList2 = val.children;
  }
    // 选中故障类型
  private selectFault2(val: any) {
    if (val.id) {
      // 东改 用户可能删除故障类型
      this.formInformation.faultTypeChild  = {};
      this.faultList3 = [];
      this.getFault(val.id,3, true);
    }
    // this.faultList2 = val.children;
  }
  close() {
    this.formInformation.faultTypeParent = '';
    this.formInformation.faultType = '';
    this.formInformation.faultTypeChild = '';
    this.$emit('close', false);
  }
  // 搜索
  private searchItemHandle(val: any) {
    this.isShowSearch = val;
  }
  private searchConfirm(val:any) {
    this.formInformation.faultTypeParent = '';
    this.formInformation.faultType = '';
    this.formInformation.faultTypeChild = '';
    // this.faultList = [];
    this.faultList2 = [];
    this.faultList3 = [];
    this.$set(this.formInformation, 'faultTypeParent', { id: val.p_p_fault_type_id,
      name: val.p_p_fault_type_name });
    this.getFault(val.p_p_fault_type_id, 2,false);
    this.$nextTick(() => {
      if(parseInt(val.p_fault_type_id)>0){
        this.getFault(val.p_fault_type_id, 3,false);
        this.$set(this.formInformation, 'faultType', { id: val.p_fault_type_id,
        name: val.p_fault_type_name,
        level: val.level });
      }
      if(parseInt(val.fault_type_id)>0){
        this.$set(this.formInformation, 'faultTypeChild', { id: val.fault_type_id,
        name: val.fault_type_name,
        level: val.level });
      }
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
